@if (formWrapper().form(); as form) {
  <form [formGroup]="form">
    <div class="sub-card-body">
      <div class="grid">
        <div class="col-12">
          <div class="assessment-preset-list-header">
            <div class="info-text">
              <nb-icon pack="eva" icon="alert-circle-outline"></nb-icon>
              Jeder Prüfpunkt kann beliebig viele Feststellungen haben.
            </div>
            <label class="label" for="deprecated">Feststellung Status</label>
            <nb-select
              id="deprecated"
              [disabled]="!isEditing()"
              [selected]="assessmentPresetStatusFilter()"
              (selectedChange)="assessmentPresetStatusFilter.set($event)">
              <nb-option [value]="null">Alle</nb-option>
              <nb-option [value]="true">Überholt</nb-option>
              <nb-option [value]="false">Aktuell</nb-option>
            </nb-select>
            <button [disabled]="!isEditing()" (click)="addAssessment()" nbButton ghost status="primary">
              <nb-icon pack="eva" icon="plus-outline"></nb-icon>
              Hinzufügen
            </button>
          </div>
          @if (assessmentPresets && assessmentPresets.length > 0) {
            <div class="assessment-preset-list">
              <div formArrayName="assessmentPresets">
                @for (control of assessmentPresets.controls; track control) {
                  @if (shouldShow(control)) {
                    <div class="assessment-preset-item" [formGroupName]="$index" #assessmentItem>
                      <div class="assessment-preset-header">
                        <wr-action-select formControlName="action" [tenantId]="currentTenantId()"></wr-action-select>
                        <wr-deadline-select formControlName="checkInterval"></wr-deadline-select>
                        <div class="toggle-container">
                          <label class="label" for="deprecated">Überholt</label>
                          <nb-toggle id="deprecated" formControlName="deprecated"></nb-toggle>
                          <label class="label" for="assessment-preset-building-equipment-related">Hat TGA?</label>
                          <nb-toggle id="assessment-preset-building-equipment-related" formControlName="buildingEquipmentRelated"></nb-toggle>
                          @if (showStandardEquipmentSelect(control)) {
                            <label class="label" for="standardEquipment">Standard Bauplan</label>
                            <wr-tga-type-select
                              [tenantId]="currentTenantId()"
                              id="standardEquipment"
                              formControlName="standardEquipment">
                            </wr-tga-type-select>
                          }
                          <label class="label" for="standardAssessment">Standard</label>
                          <nb-toggle id="standardAssessment" formControlName="standardAssessment"></nb-toggle>
                        </div>
                      </div>
                      <textarea fullWidth type="text" formControlName="text" nbInput></textarea>
                      <label class="label" [for]="'basis-' + $index">Grundlage</label>
                      <textarea fullWidth [id]="'basis-' + $index" class="secondary-text" formControlName="basis" nbInput></textarea>
                      <label class="label" [for]="'reference-work-' + $index">Nachschlagewerk</label>
                      <textarea fullWidth [id]="'reference-work-' + $index" class="secondary-text" formControlName="referenceWork" nbInput></textarea>
                      <div class="text-block-section">
                        <div class="text-block-header">
                          <button nbButton ghost size="small" type="button" (click)="toggleTextBlocks(control)">
                            <nb-icon pack="eva" [icon]="isTextBlocksExpanded(control) ? 'chevron-down-outline' : 'chevron-right-outline'"></nb-icon>
                            Textbausteine ({{ textBlocks(control).length }})
                          </button>
                          <button nbButton ghost size="small" status="primary" type="button" [disabled]="!isEditing()" (click)="addTextBlock(control)">
                            <nb-icon pack="eva" icon="plus-outline"></nb-icon>
                            Hinzufügen
                          </button>
                        </div>
                        @if (isTextBlocksExpanded(control)) {
                          <div formArrayName="textBlocks" class="text-block-list">
                            @for (textBlockControl of textBlocks(control).controls; track textBlockControl) {
                              <div class="text-block-item" [formGroupName]="$index">
                                <textarea fullWidth formControlName="text" nbInput placeholder="Textbaustein..."></textarea>
                                <div class="text-block-actions">
                                  <button nbButton ghost size="small" type="button"
                                          [disabled]="!isEditing() || $index === 0"
                                          (click)="moveTextBlock(control, $index, -1)">
                                    <nb-icon pack="eva" icon="arrow-upward-outline"></nb-icon>
                                  </button>
                                  <button nbButton ghost size="small" type="button"
                                          [disabled]="!isEditing() || $index === textBlocks(control).length - 1"
                                          (click)="moveTextBlock(control, $index, 1)">
                                    <nb-icon pack="eva" icon="arrow-downward-outline"></nb-icon>
                                  </button>
                                  <button nbButton ghost size="small" status="danger" type="button"
                                          [disabled]="!isEditing()"
                                          (click)="removeTextBlock(control, $index)">
                                    <nb-icon pack="eva" icon="trash-2-outline"></nb-icon>
                                  </button>
                                </div>
                              </div>
                            }
                          </div>
                        }
                      </div>
                    </div>
                  }
                }
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </form>
}
